import { User } from 'state/types';

export const isSecurityEnabled = (user: User | null | undefined): boolean =>
  (user?.isEntraLess ?? false) && process.env.REACT_APP_IS_2FA_ENABLED === 'true';
